<template>
	<div class="discount">
		<app-subHeader :subTitle="subTitle"></app-subHeader>
		<div class="flex flexs">
			<span @click="tabChange(1)" :class="{ active: show == 1 }">金盛贵金属APP</span>
			<span @click="tabChange(2)" :class="{ active: show == 2 }">MT4交易平台</span>
			<span @click="tabChange(3)" :class="{ active: show == 3 }">MT5交易平台</span>
		</div>
		<section class="downloadapp" v-show="show == 1">
			<img class="mobileimg" src="./img/mobile_app_2.jpg">
			<h3 class="appTitle">产品优势</h3>
			<div class="lineBox">
				<img src="./img/mobile_app_06.jpg">
				<div class="rightPart">
					<p class="p11">品牌资质：</p>
					<p class="p22">香港黄金交易所行员，编号：047</p>
				</div>
			</div>
			<div class="lineBox">
				<img src="./img/mobile_app_09.jpg">
				<div class="rightPart">
					<p class="p11">专业：</p>
					<p class="p22">金盛拥有专业的分析师团队，为新手提供实用、完善的交易指导；为具备交易经验的客户提供实时、全面的行情资讯和分析评论</p>
				</div>
			</div>
			<div class="lineBox">
				<img src="./img/mobile_app_11.jpg">
				<div class="rightPart">
					<p class="p11">服务：</p>
					<p class="p22">金盛客服7*24小时在线，随时随地，为您答疑解惑</p>
				</div>
			</div>
			<div class="lineBox">
				<img src="./img/mobile_app_13.jpg">
				<div class="rightPart">
					<p class="p11"> 交易：</p>
					<p class="p22"> 采用国际通用的MT4&MT5交易平台，行情图表配备丰富的画线工具和分析指标，并倶备止损止盈等风控功能，操作简单、下单灵活</p>
				</div>
			</div>
		</section>
		<section class="MT4" v-show="show == 2">
			<section>
				<p class="p1">MT4平台 国际通用 90%交易量载体</p>
				<p class="p2">成熟、安全、精确、稳定</p>
				<div class="flat">
					<img src="./img/flat.png">
				</div>
				<div class="txt">
					<p>• 18种划线工具</p>
					<p>• 9种交易的时段表</p>
					<p>• 30种国际流行的指标</p>
					<p>• 多种自定义功能</p>
				</div>
			</section>
			<div class="sixElements">
				<p>金盛 :MetaTrader4<span class="gap">开发者信息:MetaQuotes Software Corp.</span></p>
				<p>最新版本:Android:400.1402</p>
				<p>
					隐私权限：<b class="link" @click="openPopup('yingsi')">查看权限</b>
					<span class="gap">用户权限：<b class="link" @click="openPopup('yonghu')">查看权限</b></span>
					<span class="gap">功能介绍：<b class="link" @click="openPopup('gongneng')">查看详情</b></span>
				</p>
			</div>
			<section>
				<div class="loadBox">
					<p class="h2">IOS版</p>
					<div class="flex">
						<p class="text">
							浏览iPhone里的App Store,搜索MetaTrader4。点击下载安装即可使用。或扫描右侧二维码下载
						</p>
						<img class="icon" src="./img/jmt4.png">
					</div>
					<a class="btn" href="https://itunes.apple.com/cn/app/metatrader-4/id496212596?mt=8">立即下载</a>
				</div>
				<div class="loadBox">
					<p class="h2">Android版</p>
					<div class="flex">
						<p class="text">
							点击下载Golday.apk安装到手机。或扫描右侧二维码下载
						</p>
						<img class="icon" src="./img/jmt4.png">
					</div>
					<a class="btn btn1" href="https://vip.golday99.com/GoldayMT4.apk">立即下载</a>
				</div>
			</section>
		</section>
		<section class="MT4" v-show="show == 3">
			<section>
				<p class="p1">MT5交易平台提供多样化交易功能，全面的技术市场分析，和复制交易功能。</p>

				<div class="flat">
					<img src="./img/download5.png">
				</div>
				<div class="txt mt8">
					<p>• 38 种技术指标</p>
					<p>• 44 种分析对象</p>
					<p>• 21 种时间周期</p>
					<p>• 图表数量无上限</p>
				</div>
			</section>
			<div class="sixElements">
				<p>金盛 :MetaTrader5<span class="gap">开发者信息:MetaQuotes Software Corp.</span></p>
				<p>最新版本:Android:400.6002</p>
				<p>
					隐私权限：<b class="link" @click="openPopup('yingsi')">查看权限</b>
					<span class="gap">用户权限：<b class="link" @click="openPopup('yonghu')">查看权限</b></span>
					<span class="gap">功能介绍：<b class="link" @click="openPopup('gongneng')">查看详情</b></span>
				</p>
			</div>
			<section>
				<div class="loadBox">
					<p class="h2">IOS版</p>
					<div class="flex">
						<p class="text">
							浏览iPhone里的App Store,搜索MetaTrader5。点击下载安装即可使用。或扫描右侧二维码下载
						</p>
						<img class="icon" src="./img/download_mt5.png">
					</div>
					<a class="btn" href="https://apps.apple.com/cn/app/metatrader-5/id413251709">立即下载</a>
				</div>
				<div class="loadBox">
					<p class="h2">Android版</p>
					<div class="flex">
						<p class="text">
							点击下载Golday.apk安装到手机。或扫描右侧二维码下载
						</p>
						<img class="icon" src="./img/download_mt5.png">
					</div>
					<a class="btn btn1" href="https://vip.golday99.com/GoldayMT5.apk">立即下载</a>
				</div>
			</section>
		</section>

		<!-- 隐私政策弹窗（与官网底部一致） -->
		<section class="mask" v-if="yingsi">
			<div class="content">
				<div class="topTitles">隐私政策</div>
				<span class="close" @click="closePopup('yingsi')"> × </span>
				<div class="scroll">
					<p class="incent">
						香港金盛贵金属有限公司（下称“交易商”）根据《个人资料(隐私条例》来保护客户的个人资料隐私。在交易商使用客户资料以提供其最佳之服务时，亦会高度关注对于客户资料使用之安排。交易商会根据香港特别行政区法例《个人资料(隐私)条例》之规定，力求完全符合个人资料保证要求。为此，交易商会确保其雇员遵守法例规定的保安和保密严谨标准。
					</p>
					<p>1、为保障客户正常使用服务，维护服务的正常运行，改进及优化服务体验以及保障账户安全，可能需要客户授权使用如下个人权限：
						实名认证：确保客户信息准确无误；相机/相册：发送图片，选取图片上传，存储照片，扫一扫，用于反馈意见和个人信息审核时使用； 银行卡识别：为保障客户资金安全，需进行银行卡审核；
						用户地址：主要用于发放实物奖励。</p>
					<p>2、交易商收集的各项个人资料，只供应业务运作及其他有关活动之用。</p>
					<p>3、关于使用Cookies技术：交易商可能会在客户及存款交易商的电脑设定cookies，可能会于交易商的产品和服务中使用cookies来分析客户在交易商网站的浏览行为，以协助交易商更好的了解客户需求及提供更好的服务方式，但对于收集得来和共用的资料是不具姓名及无法被个别识别的。
					</p>
					<p>4、信息储存：交易商会按照法律法规规定，将收集的用户信息存储于中国香港服务器。一般而言，我们仅为实现对客服务所必需的时间保留客户的用户信息。</p>
					<p>5、信息安全保护：交易商致力于使用防火墙、密码和个人身份证号码认证系统和操控机制来控制未授权的系统进入和存储资料，或使用其他资料保障工具确保网站安全及符合业界标准。</p>
					<p>6、交易商不会将客户个人资料用于用户画像、个性化展示，也不会收集关于您设备上安装的其他APP信息。交易商使用客户的用户信息，超出了与收集时声称的目的及具有直接或合理关联的范围，将会在使用用户信息前，再次告知并征求客户的明示同意（通过主动点击“确认”做出直接性动作）
						。</p>
					<p>7、交易商会将客户个人资料保密储存，防止其个人资料被盗用，未达到隐私保护之最佳效果，除符合本款第五、第七条之规定外，客户充分理解交易商不会向客户本人以外的任何主体提供客户的资料、信息，即使该主体声称其为授权。
					</p>
				</div>
			</div>
		</section>

		<!-- 用户权限弹窗 -->
		<section class="mask" v-if="yonghu">
			<div class="content">
				<div class="topTitles">用户权限</div>
				<span class="close" @click="closePopup('yonghu')"> × </span>
				<div class="scroll">
					<p>为保障客户正常使用服务，维护服务的正常运行，改进及优化服务体验以及保障账户安全，可能需要客户授权使用如下个人权限：</p>
					<p>• 存储：存储图片；</p>
					<p>• 相机/相册：扫一扫登录官网、金荣圈、头像等选取图片上传；</p>
					<p>• 麦克风：身份认证、客服系统语音发送；</p>
				</div>
			</div>
		</section>

		<!-- 功能介绍弹窗 -->
		<section class="mask" v-if="gongneng">
			<div class="content">
				<div class="topTitles">功能介绍</div>
				<span class="close" @click="closePopup('gongneng')"> × </span>
				<div class="scroll">
					<p class="featTitle">功能详情</p>
					<p class="featSub">实时行情，掌握市场动态</p>
					<p>提供国际市场行情报价与多周期K线图，支持分时、分钟、小时、日线等多维度查看。常用技术指标与画线工具灵活切换，帮助您更高效地观察价格走势与市场变化。</p>
					<p class="featSub">便捷交易，操作更高效</p>
					<p>支持市价、挂单等多种交易操作，可快速查看当前持仓、委托订单及历史交易记录。通过一键平仓、修改止盈止损、撤销挂单等功能，让交易管理更加便捷清晰。</p>
					<p class="featSub">专业图表，辅助交易决策</p>
					<p>内置丰富的技术分析工具，包括趋势线、斐波那契工具及多种常用指标。支持多个品种、多个周期同屏查看，满足不同交易习惯下的行情分析需求。</p>
					<p class="featSub">账户信息，一站式管理</p>
					<p>资金状况、可用保证金、浮动盈亏及交易明细等账户数据清晰呈现。您可随时了解账户与订单状态，合理安排交易计划。</p>
					<p class="featSub">个性化设置，贴合使用习惯</p>
					<p>支持深色/浅色界面切换及自定义图表配色，可根据个人偏好调整报价窗口、图表布局和常用功能，打造更舒适的交易体验。</p>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import subHeader from '../header/SubHeader'
export default {
	name: 'discount',
	data() {
		return {
			subTitle: '平台下载',
			show: 1,
			yingsi: false,
			yonghu: false,
			gongneng: false,
		}
	},
	methods: {
		tabChange(num) {
			this.show = num
		},
		openPopup(type) {
			this[type] = true
		},
		closePopup(type) {
			this[type] = false
		},
	},
	components: {
		'app-subHeader': subHeader,
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.discount {
	background: #fff;
}

.flexs {
	margin: 0;
	width: 7.1rem;
	margin: 0 auto;
	height: 0.88rem;
	background-color: #fafafa;
	border-radius: 0.1rem;
	border: solid 0.01rem #ec615c;
}

.flexs span {
	width: 2.3rem;
	text-align: center;
	height: 0.88rem;
	line-height: 0.88rem;
	font-size: 0.3rem;
	color: #999999;
}

.flexs .active {
	background-color: #ec615c;
	border-radius: 3px;
	color: #fff;
}

.downloadapp {
	width: 7.5rem;
	padding: 0.2rem 0.2rem 0.8rem;
	box-sizing: border-box;
	background: #fff;
}

.mobileimg {
	width: 7.1rem;
	margin: 0 auto 0.8rem;
	display: block;
}

.appTitle {
	font-size: 0.36rem;
	color: #333333;
}

.lineBox {
	margin-top: 0.4rem;
}

.lineBox img {
	width: 0.36rem;
	height: 0.34rem;
	vertical-align: top;
	float: left;
	margin: 0.1rem 0.25rem 0 0;
}

.lineBox .rightPart {
	display: table-cell;
	vertical-align: top;
}

.p11 {
	font-size: 0.36rem;
	color: #090909;
}

.p22 {
	font-size: 0.3rem;
	color: #333333;
	line-height: 0.35rem;
}

.p1 {
	width: 88%;
	margin: 0 auto;
	font-size: 0.32rem;
	padding-top: 0.3rem;
	text-align: center;
	color: #000;
}

.p2 {
	font-size: 0.28rem;
	margin-bottom: 0.4rem;
	text-align: center;
	color: #565656;
}

.flat {
	padding-left: 1.35rem;
	width: 4.75rem;
	display: inline-block;
	margin-top: 0.4rem;
}

.flat img {
	width: 3rem;
}

.txt {
	display: inline-block;
	vertical-align: top;
	margin-top: 0.2rem;
}

.mt8 {
	margin-top: 0.8rem;
}

.txt p {
	font-size: 0.22rem;
	line-height: 0.4rem;
	color: #808080;
}

.sixElements {
	width: 6.9rem;
	margin: 0.3rem auto 0.1rem;
	font-size: 0.2rem;
	line-height: 0.32rem;
	color: #aeaeae;
}

.sixElements p {
	padding-left: .2rem;
}

.sixElements .gap {
	margin-left: 0.24rem;
}

.sixElements .link {
	font-weight: normal;
	color: #666;
	text-decoration: underline;
	cursor: pointer;
}

.loadBox {
	border: 1px solid #d6d7dc;
	width: 6.9rem;
	margin: 0.3rem auto 0;

	border-radius: 5px;
	box-sizing: border-box;
	padding: 0.3rem;
	background: #fff;
	font-size: 0;
}

.MT4 {
	padding-bottom: 0.5rem;
}

.loadBox .h2 {
	color: #000;
	font-size: 0.32rem;
}

.flex {
	margin-top: 0.2rem;
}

.text {
	color: #808080;
	font-size: 0.28rem;
	flex: 2;
	-webkit-flex: 2;
}

.icon {
	width: 2.15rem;
	flex: 1;
	vertical-align: top;
}

.btn {
	border-radius: 5px;
	border: 1px solid #666;
	display: inline-block;
	height: 0.5rem;
	line-height: 0.5rem;
	padding: 0 0.2rem 0 0.45rem;
	background: url(./img/download_03.png) no-repeat left 0.15rem center;
	background-size: 0.19rem 0.26rem;
	font-size: 0.3rem;
}

.btn1 {
	background: url(./img/download_04.png) no-repeat left 0.15rem center;
	background-size: 0.19rem 0.26rem;
}

.mask {
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.3);
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1000;
}

.content {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	border-radius: 7px;
	background: #fff;
	width: 6.5rem;
	height: 8rem;
}

.content .topTitles {
	width: 100%;
	height: 0.7rem;
	line-height: 0.7rem;
	text-align: center;
	color: #fff;
	font-size: 0.32rem;
	background-color: #ff5555;
	border-radius: 3px 0px 0px;
	margin-bottom: 0.3rem;
}

.content .scroll {
	width: 100%;
	height: 6.6rem;
	overflow-y: scroll;
}

.content .close {
	width: 0.35rem;
	height: 0.35rem;
	line-height: 0.32rem;
	color: #fff;
	font-size: 0.26rem;
	text-align: center;
	position: absolute;
	top: 0.08rem;
	right: 0.08rem;
	border: solid 1px #ffffff;
	border-radius: 30px;
	cursor: pointer;
}

.content p {
	font-size: 0.26rem;
	text-align: left;
	line-height: 0.4rem;
	color: #333;
	width: 92%;
	margin: 0.08rem auto;
}

.content .incent {
	text-indent: 0.4rem;
}

.content .featTitle {
	font-size: 0.3rem;
	font-weight: bold;
	color: #333;
}

.content .featSub {
	font-size: 0.28rem;
	font-weight: bold;
	color: #333;
	margin-top: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/trade/Download.vue